import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" style={{ height: "200px", objectFit: "cover" }} />
      <Card.Body>
        <Card.Title style={{ fontWeight: "bold", fontSize: "1.3em" }}>{props.title}</Card.Title>
        {props.industry && (
          <div style={{ marginBottom: "10px" }}>
            <span
              className="project-card-badge"
              style={{
                backgroundColor: "rgba(123, 31, 162, 0.2)",
                color: "rgb(155 126 172)",
                padding: "4px 12px",
                borderRadius: "15px",
                fontSize: "0.85em",
                fontWeight: "500",
              }}
            >
              {props.industry}
            </span>
          </div>
        )}
        <Card.Text style={{ textAlign: "justify", fontSize: "0.95em" }}>
          {props.description}
        </Card.Text>
        <div
          className="project-card-actions"
          style={{ display: "flex", gap: "10px", marginTop: "15px" }}
        >
          {props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              style={{ flex: 1 }}
            >
              <CgWebsite /> &nbsp;
              {"Visit Site"}
            </Button>
          )}
          {props.ghLink && (
            <Button 
              variant="outline-primary" 
              href={props.ghLink} 
              target="_blank"
              style={{ flex: props.demoLink ? 0 : 1 }}
            >
              <BsGithub />
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
